import * as React from 'react'

import { Button } from '../button/Button'
import { Divider } from '../divider/Divider'
import { useDataTable } from './DataTableContext'

export const BulkActionsSelectedRowActions = ({
  cancelLabel = 'Cancel',
  showDividers = true,
  children
}: {
  cancelLabel?: string
  showDividers?: boolean
  children: React.ReactNode
}) => {
  const { toggleAllPageRowsSelected, rowSelection } = useDataTable()

  const handleDeselectAllPageRows = () => toggleAllPageRowsSelected(false)

  if (Object.keys(rowSelection || {}).length === 0) return null

  return (
    <>
      {children}
      {showDividers && React.Children.count(children) > 0 && (
        <Divider orientation="vertical" className="mx-4" />
      )}
      <Button theme="neutral" onClick={handleDeselectAllPageRows}>
        {cancelLabel}
      </Button>
    </>
  )
}
